import React from "react"
const Setting = () => {
    


    return(
        <React.Fragment>
            <div className="aside-heading">
                <h3>SETTING</h3>
            </div>
        </React.Fragment>
    )
};
export default Setting;